/**
 * Copiloto DataFlow — gera recomendações acionáveis a partir dos dados existentes.
 */

import type { DataflowCopilotAction } from '../components/dataflow/DataflowCopilot';
import type { LstScreen } from '../components/LstScreenTabs';
import type { TplManagementHubData } from './tplManagementHubInsights';

export interface BuildCopilotActionsInput {
  hub?: TplManagementHubData | null;
  disciplinaPct: number;
  rotinasSemKpi: number;
  escalonamentosVencidos: number;
  onNavigate?: (screen: LstScreen) => void;
}

export function buildDataflowCopilotActions(input: BuildCopilotActionsInput): DataflowCopilotAction[] {
  const { hub, disciplinaPct, rotinasSemKpi, escalonamentosVencidos, onNavigate } = input;
  const actions: DataflowCopilotAction[] = [];

  const conflicts = hub?.totalConflicts ?? 0;
  if (conflicts > 0) {
    actions.push({
      id: 'planner-conflicts',
      message: `Detectamos ${conflicts} conflito${conflicts > 1 ? 's' : ''} de agenda.`,
      actionLabel: 'Corrigir automaticamente',
      severity: conflicts >= 5 ? 'critico' : 'atencao',
      onAction: onNavigate ? () => onNavigate('construtor') : undefined,
    });
  }

  if (rotinasSemKpi > 0) {
    actions.push({
      id: 'missing-kpi',
      message: `${rotinasSemKpi} rotina${rotinasSemKpi > 1 ? 's estão' : ' está'} sem KPI.`,
      actionLabel: 'Sugerir indicadores',
      severity: rotinasSemKpi >= 5 ? 'atencao' : 'informativo',
      onAction: onNavigate ? () => onNavigate('configuracao') : undefined,
    });
  }

  if (disciplinaPct < 70) {
    actions.push({
      id: 'low-discipline',
      message: `Disciplina abaixo de 70% (${disciplinaPct}%).`,
      actionLabel: 'Gerar plano de recuperação',
      severity: 'critico',
      onAction: onNavigate ? () => onNavigate('meu-padrao') : undefined,
    });
  }

  if (escalonamentosVencidos > 0) {
    actions.push({
      id: 'overdue-escalation',
      message: `${escalonamentosVencidos} escalonamento${escalonamentosVencidos > 1 ? 's' : ''} vencido${escalonamentosVencidos > 1 ? 's' : ''}.`,
      actionLabel: 'Tratar agora',
      severity: 'critico',
      onAction: onNavigate ? () => onNavigate('cadeia-ajuda') : undefined,
    });
  }

  const overdueActions = hub?.actionSummary.emAtraso ?? 0;
  if (overdueActions > 0) {
    actions.push({
      id: 'overdue-actions',
      message: `${overdueActions} ação${overdueActions > 1 ? 'ões' : ''} corretiva${overdueActions > 1 ? 's' : ''} em atraso.`,
      actionLabel: 'Ver ações',
      severity: 'atencao',
      onAction: onNavigate ? () => onNavigate('central-gestao') : undefined,
    });
  }

  return actions.slice(0, 5);
}
